import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeatureFlagService, filterNulls, TranslatePipe} from '@brunata-angular/util';
import {DatePipe, NumberPipe, TrueFalseComponent} from '@brunata-angular/ui';
import {MeterData} from '../meter-data.model';
import {map} from 'rxjs';
import {ShutoffValvePipe} from '@shared/pipes/shutoff-valve.pipe';
import {selectBuilding} from 'src/app/state/selectors';
import {Store} from '@ngrx/store';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-meter-and-system-information',
    templateUrl: './meter-and-system-information.component.html',
    styleUrl: './meter-and-system-information.component.scss',
    imports: [
        CommonModule,
        TranslatePipe,
        DatePipe,
        TrueFalseComponent,
        ShutoffValvePipe,
        NumberPipe,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterAndSystemInformationComponent {
    @Input({required: true}) meterData!: MeterData;

    private readonly store = inject(Store);
    private readonly featureFlagService = inject(FeatureFlagService);

    protected readonly deviceDetailsEnabled = toSignal(
        this.featureFlagService.isFeatureEnabled$('agi-20301-device-details'),
        {initialValue: false},
    );

    readonly view$ = this.store.select(selectBuilding).pipe(
        map(buildingState =>
            buildingState.status === 'success' ? buildingState.buildingDetails.building : null,
        ),
        filterNulls(),
        map(building => ({
            buildingNo: building.buildingNo,
        })),
    );
}
